import React, { forwardRef, type ForwardedRef } from 'react';
import { clsx } from '@mentimeter/ragnar-tailwind-config';
import { Clickable, type ClickableT } from '../clickable/tw';
import { actionVariants } from './Action.variants';

export type ActionT = ClickableT & {
  activeStateStyle?: 'outline' | 'filledIn';
  // States
  active?: boolean | undefined;
  disabled?: boolean | undefined;
  danger?: boolean | undefined;
  hidden?: boolean | undefined;
};

export const Action = forwardRef(
  (
    {
      disabled,
      danger,
      active = false,
      activeStateStyle = 'outline',
      hidden,
      className,
      ...props
    }: ActionT,
    ref,
  ) => {
    const defaultClasses = actionVariants({
      border: danger ? 'danger' : active ? 'active' : undefined,
      hidden,
    });

    return (
      <Clickable
        ref={ref as ForwardedRef<HTMLButtonElement | HTMLAnchorElement>}
        disabled={disabled}
        className={clsx(
          defaultClasses,
          activeStateStyle === 'filledIn' && active && 'bg-primary',
          className,
        )}
        {...props}
      />
    );
  },
);

Action.displayName = 'Action';
